import { Button } from 'Components/Core';
import { IconSettings } from 'Lib/Icons';
import { useState } from 'react';
import { useSelector } from 'react-redux';
import { WorksheetBatchUpdateConfigurationDialog } from '.';

/**
 * Component that provides a button to configure the batch update page
 * and controls the display of the associated dialog
 */
const WorksheetBatchUpdateConfigurationDialogButton: React.FC = () => {
  const showByDefault = useSelector((state) => !state.worksheetBatchUpdate.status.initialised);
  const [showDialog, setShowDialog] = useState<boolean>(showByDefault);

  const canConfigure = useSelector(
    (state) =>
      !state.worksheetBatchUpdate.status.refreshingWorksheets &&
      !state.worksheetBatchUpdate.status.applyingUpdate &&
      !state.worksheetBatchUpdate.status.checking &&
      !state.worksheetBatchUpdate.status.configuring
  );

  return (
    <>
      <WorksheetBatchUpdateConfigurationDialog visible={showDialog} onClose={() => setShowDialog(false)} />
      <Button subtle onClick={() => setShowDialog(true)} disabled={!canConfigure}>
        <IconSettings size={'1.25em'} />
      </Button>
    </>
  );
};

export { WorksheetBatchUpdateConfigurationDialogButton };
export default WorksheetBatchUpdateConfigurationDialogButton;
